export const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/18631424/pexels-photo-18631424.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  film: "https://images.pexels.com/photos/36423801/pexels-photo-36423801.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  factory: "https://images.pexels.com/photos/38336747/pexels-photo-38336747.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const CARD_IMAGES = ["/assets/preformes-card.jpg", "/assets/bouchons-card.jpg", "/assets/film-card.jpg", "/assets/gobelets-card.jpg"];
export const PANEL_IMAGES = ["/assets/preformes-panel.jpg", "/assets/bouchons-panel.jpg", "/assets/film-panel.jpg", "/assets/gobelets-panel.jpg"];
